<btw-academy-header/>
<div class="app-container about-values pt-4 pb-5">
  <h2>BMW TechWorks Academy</h2>
  <p class="mt-4 about-text">
    The educational and development platform of BMW TechWorks Romania, created to
    connect the academic world with the real-world challenges of technology and innovation.
    The Academy aims to nurture a new generation of professionals in IT, software engineering, and automotive
    technology, providing access to mentors, resources, and hands-on learning experiences within a collaborative
    environment.
  </p>

  <p class="about-text">
    Through its mentorship programs, internships, and continuous learning initiatives, the Academy supports students and
    young professionals in making a smooth transition toward successful technology careers.
    Its activities include applied training, thematic workshops, interdisciplinary projects, innovation events, and
    partnerships with universities in Romania and abroad.
  </p>

  <p class="about-text">
    The mission of BMW TechWorks Romania Academy is to develop future-ready skills, foster technological culture, and
    build an educational ecosystem where ideas, research, and innovation meet.
    It is a place where passion for technology evolves into professional excellence and responsible leadership.
  </p>
</div>

<div class="app-container our-values pb-5 pt-5">
  <div class="btw-academy-cards">
    @for (item of infoCards; track item.title) {
      <box-item-flip
        [content]="item.content"
        [description]="item.description"
        [imgClass]="item.imgClass"
        [title]="item.title"
        [url]="item.url">
      </box-item-flip>
    }
  </div>
</div>
